"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxIcon = CheckboxIcon;
exports.CheckboxIconNames = void 0;
var _core = require("@blueprintjs/core");
var _react = _interopRequireDefault(require("react"));
var _Icon = require("./Icon");
var _excluded = ["icon", "fill", "fillOpacity", "style"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * We don't want these as part of our normal icon set, as they're only to be used internally for checkboxes,
 * rather than decorative icons.
 */
var CheckboxIconNames = /*#__PURE__*/function (CheckboxIconNames) {
  CheckboxIconNames["CHECKED"] = "checked";
  CheckboxIconNames["INDETERMINATE"] = "indeterminate";
  CheckboxIconNames["UNCHECKED"] = "unchecked";
  return CheckboxIconNames;
}({});
exports.CheckboxIconNames = CheckboxIconNames;
var checkboxIconPaths = {
  checked: /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 16H0V0H16V16ZM6.50488 8.73145L5.20508 7.43359L3.79102 8.84863L6.50781 11.5615L12.208 5.85059L10.792 4.43848L6.50488 8.73145Z"
  }),
  indeterminate: /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 16H0V0H16V16ZM4 7V9H12V7H4Z"
  }),
  unchecked: /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 16H0V0H16V16ZM1 15H15V1H1V15Z"
  })
};
function CheckboxIcon(_ref) {
  var icon = _ref.icon,
    fill = _ref.fill,
    fillOpacity = _ref.fillOpacity,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  var iconArgs = {
    path: checkboxIconPaths[icon],
    iconSize: 16,
    nativeIconSize: 16,
    fill: fill,
    fillOpacity: fillOpacity,
    style: style
  };
  return /*#__PURE__*/_react.default.createElement(_core.Icon, _extends({
    icon: (0, _Icon.svgIconWrapper)(iconArgs)
  }, props));
}